module.exports = __webpack_public_path__ + "media/images/ibjjf/safe-sport-2-1b6b339d7d2b6ac29d4b67a2f551b0c9.svg";